<template>

    <div class="contactColumn col-md-3">
        <img :src="img" alt="Profilbilde"/>
        <div class="info">
            <h4>Kontakt</h4>
            <ul class="profile-contact">
                <li>{{name}}</li>
            
                <li>{{study}}</li>
            
                <li>{{phone}}</li>
        
                <li><p style="word-break:break-all;">{{email}}</p></li>
            </ul>
            <ul class="profile-links">
                <a><li><b-icon icon="linkedin"></b-icon></li></a>
                <a><li><b-icon icon="github"></b-icon></li></a>
                <a><li><b-icon icon="globe"></b-icon></li></a>
            </ul>
        </div>
    
    </div>
</template>
<script>
export default {
    name: "ContactColumn",
    props:["img", "email", "phone", "editable", "name", "study"]
}

</script>